<script>
import { layoutMethods, coreEloadSKUSchedulingMethods, coreEloadSKUSchedulingComputed, exportMethods } from '@/state/helpers';
import Swal from 'sweetalert2';
import { getModuleAccess } from '@/router/helper.js';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  page: {
    title: "E-Load Scheduler",
  },
  components: {
    flatPickr,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50],
      sortBy: "id",
      sortDesc: true,
      searchFieldOptions: [
        { text: "Search All", value: null },
        { text: "Promo Name", value: 'sku_name' },
        // { text: "SKU Code", value: 'sku_code' },
        // { text: "Description", value: 'description' }
      ],
      fields: [
        {
          key: "action",
          label: "Action",
          sortable: false,
          thStyle: { width: "80px" }
        },
        {
          key: "sku_name",
          label: "Current Promo Name",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "scheduleStart",
          label: "Schedule Start Date",
          sortable: true,
        },
        {
          key: "scheduleEnd",
          label: "Schedule End Date",
          sortable: true,
        },
        {
          key: "promoName",
          label: "Scheduled Promo Name",
          sortable: true,
        },
        {
          key: "skuCode",
          label: "Scheduled SKU Code",
          sortable: true,
        },
        {
          key: "provider",
          label: "Scheduled Provider",
          sortable: true,
        },
        {
          key: "amount",
          label: "Scheduled Amount",
          sortable: true,
        },
        {
          key: "validity",
          label: "Scheduled Validity",
          sortable: true,
        },
        {
          key: "description",
          label: "Scheduled Description",
          sortable: false,
        },
        {
          key: "created_by",
          label: "Added By",
          sortable: true,
        },
      ],
      searchValue: {
        search: "",
        status: null,
        dateRange: null,
        searchField: null,
      },
      dateConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        placeholder: "Select date range",
      },
      statusList: [
        { text: "All", value: null },
        { text: "Scheduled", value: "Scheduled" },
        { text: "Ongoing", value: "Ongoing" },
        { text: "Ended", value: "Ended" },
        { text: "Cancelled", value: "Cancelled" },
        { text: "Force Cancelled", value: "Force Cancelled" }
      ],
      schedulerModule: {
        access: {
          create: true,
          update: true,
          delete: true
        }
      },
    };
  },
  computed: {
    ...coreEloadSKUSchedulingComputed,
  },
  mounted: async function() {
    await this.loadScheduleData();
    this.changeTitle({title: 'E-Load Scheduler'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'}},
        { text: 'E-Load Core Manager' },
        { text: 'E-Load Scheduler' }
      ]
    });

    await getModuleAccess('Products', 'eLoad', 'eLoad Scheduler')
      .then((access) => this.schedulerModule.access = access)
      .catch(() => this.schedulerModule.access = { create: true, update: true, delete: true });
  },
  methods: {
    ...layoutMethods,
    ...coreEloadSKUSchedulingMethods,
    ...exportMethods,
    async loadScheduleData() {
      await this.actionCoreEloadSKUSchedulingAPIPOST({
        params: {
          page: this.currentPage,
          rows: this.perPage,
          sort: this.sortBy,
          orderDesc: this.sortDesc,
          ...this.searchValue
        },
        action: 'list'
      });
    },
    
    async onPageUpdate(reset = "") {
      if (reset === "reset") {
        this.currentPage = 1;
      }
      await this.loadScheduleData();
    },
    async onSearch() {
      await this.onPageUpdate("reset");
    },
    async onRefresh() {
      this.searchValue = {
        search: "",
        status: null,
        dateRange: null,
        searchField: null,
      };
      await this.onPageUpdate("reset");
    },
   
    async onExport() {
      await this.onPageUpdate("reset");
      if (this.loadPromoTotalRows === 0) {
        Swal.fire("Failed!", "No data to export", "warning");
      } else {
        let params = {
          email: JSON.parse(localStorage.getItem('userData')).email,
          sort: this.sortBy,
          orderDesc: this.sortDesc,
          ...this.searchValue
        };

        this.actionCoreEloadSKUSchedulingAPIPOST({
          params: params,
          action: 'export'
        })
          .then(() => Swal.fire("Success!", "Your request for reports is pending. It will be sent to your email once it's ready.", "success"))
          .catch(() => Swal.fire("Failed!", "Your request for reports has failed.", "warning"));
      }
    },
    async onDisplayChange() {
      this.currentPage = 1;
      await this.onPageUpdate();
    },
    async scheduleSort(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.currentPage = 1;
      await this.onPageUpdate();
    },
    viewSchedule(item) {
      this.$router.push({ 
        name: 'E-Load Core SKU Schedule Form', 
        params: { id: item.id } 
      });
    },
    async cancelSchedule(item) {
      const isScheduled = item.status === 'Scheduled';
      const isOngoing = item.status === 'Ongoing';
      
      if (!isScheduled && !isOngoing) {
        return;
      }

      try {
        let result;
        
        if (isScheduled) {
          // Cancel scheduled promo
          result = await Swal.fire({
            title: 'Cancel Promo Scheduled',
            html: 'Are you sure you want to cancel this scheduled promo?<br><br>This action will remove the schedule and will not apply any changes on the start date.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#6C5CE7',
            cancelButtonColor: '#C12927',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
          });
        } else {
          // Force cancel ongoing promo
          result = await Swal.fire({
            title: 'Force Cancel Schedule?',
            html: 'This schedule is already in progress. If you force cancel it, the promo changes will immediately stop and the SKU will revert to its previous settings.<br><br>Do you want to continue?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#6C5CE7',
            cancelButtonColor: '#C12927',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
          });
        }

        if (result.isConfirmed) {
          const response = await this.actionCoreEloadSKUSchedulingAPIPOST({
            params: { 
              id: item.id,
              status: isScheduled ? 'cancel' : 'force-cancel'
            },
            action: 'update-status'
          });

          if (response.status === 'ok') {
            await this.loadScheduleData();

            if (isScheduled) {
              Swal.fire({
                title: 'Promo Schedule Cancelled',
                text: 'The scheduled promo has been successfully cancelled.',
                icon: 'success',
                confirmButtonColor: '#6C5CE7',
                confirmButtonText: 'OK'
              });
            } else {
              Swal.fire({
                title: 'Promo Schedule Cancelled',
                html: 'The ongoing schedule has been successfully canceled.<br><br>The SKU has been reverted to its previous settings.',
                icon: 'success',
                confirmButtonColor: '#6C5CE7',
                confirmButtonText: 'OK'
              });
            }
          } else {
            Swal.fire(
              "Error!",
              response.message || "Failed to cancel schedule.",
              "error"
            );
          }
        }
      } catch (error) {
        console.error('Error cancelling schedule:', error);
        Swal.fire(
          "Error!", 
          "An unexpected error occurred. Please try again.", 
          "error"
        );
      }
    },
    getStatusClass(status) {
      const statusClasses = {
        'Scheduled': 'badge-scheduled',
        'Ongoing': 'badge-ongoing',
        'Ended': 'badge-ended',
        'Cancelled': 'badge-cancelled',
        'Force Cancelled': 'badge-force-cancelled'
      };
      return statusClasses[status] || '';
    }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-12">
                <div class="mt-2 mb-3">
                  <h5 class="card-title">
                    <span class="fw-normal ms-2">{{ loadPromoTotalRows }}</span> Record(s)
                  </h5>
                </div>
              </div>

              <div class="col-md-8 col-sm-12 text-end mb-3">
                <router-link :to="{ name: 'E-Load Core SKU Schedule Form', params: { id: 0 } }">
                  <button class="btn btn-primary me-2">
                    <i class="uil uil-plus me-1"></i> Schedule E-Load
                  </button>
                </router-link>

                <button class="btn btn-secondary" @click="onRefresh">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>
                  &nbsp;&nbsp;Refresh
                </button>
              </div>

              <div class="col-md-12 col-sm-12">
                <div class="row">
                  <div class="col-md-3 mb-3 ta-right">
                    <b-form-group description="Search Keyword" class="mb-0">
                      <form class="d-flex" @submit.prevent="onSearch">
                        <b-form-select
                          class="form-select rounded-0 rounded-start shadow-none"
                          style="width: fit-content; min-width: 120px;"
                          v-model="searchValue.searchField"
                          :options="searchFieldOptions"
                        ></b-form-select>
                        <b-input-group class="flex-grow-1">
                          <b-form-input
                            class="rounded-0 rounded-end"
                            v-model="searchValue.search"
                            placeholder="Search..."
                          ></b-form-input>
                        </b-input-group>
                      </form>
                    </b-form-group>
                  </div>

                  <div class="col-md-9">
                    <div class="d-flex ta-right gap-2 mb-3">
                      <div style="min-width: 130px;">
                        <b-form-group label-for="status" description="Filter by Status" class="mb-0">
                          <b-form-select
                            class="form-select rounded-0 shadow-none"
                            v-model="searchValue.status"
                            :options="statusList"
                          ></b-form-select>
                        </b-form-group>
                      </div>

                      <div style="min-width: 200px;">
                        <b-form-group label-for="dateRange" description="Filter by Schedule Date" class="mb-0">
                          <flat-pickr
                            v-model="searchValue.dateRange"
                            :config="dateConfig"
                            class="form-control rounded-0 shadow-none"
                            placeholder="Select date range"
                          ></flat-pickr>
                        </b-form-group>
                      </div>

                      <div class="d-flex ta-right" style="padding-top: 0;">
                        <b-button
                          variant="primary"
                          type="button"
                          @click="onSearch"
                          class="px-3 me-2"
                          style="height: 38px;"
                        >
                          <i class='bx bx-search me-1'></i>
                          <span>Search</span>
                    </b-button>

                        <b-button
                          variant="primary"
                          @click="onExport"
                          type="button"
                          class="px-3"
                          style="height: 38px;"
                        >
                          <i class='uil uil-export me-1'></i>
                          <span>Export</span>
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="loadPromoList"
                  :fields="fields"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :no-local-sorting="true"
                  class="table-check"
                  @sort-changed="scheduleSort"
                >
                  <template #cell(action)="data">
                    <div class="d-flex gap-2 align-items-center">

                      <button type="button" class="btn btn-sm btn-danger" v-if="data.item.status === 'Scheduled'"
                        @click="cancelSchedule(data.item)"
                      >
                        <i class="mdi mdi-calendar-remove"></i>
                      </button>
                      <button type="button" class="btn btn-sm btn-danger"  v-if="data.item.status === 'Ongoing'"
                        @click="cancelSchedule(data.item)">
                        <i class="mdi mdi-close-circle-outline"></i>
                      </button>
                      <!-- <button
                        v-if="data.item.status === 'Scheduled'"
                        @click="cancelSchedule(data.item)"
                        class="action-btn action-btn-danger"
                      >
                        <i class="bx bx-calendar-x fs-6"></i>
                      </button>

                      <button
                        v-if="data.item.status === 'Ongoing'"
                        @click="cancelSchedule(data.item)"
                        class="action-btn action-btn-danger"
                      >
                      <span class="mdi mdi-close-circle-outline fs-6"></span>
                      </button> -->
                    </div>
                  </template>

                  <template #cell(sku_name)="data">
                    <b-link class="fw-medium text-primary" @click="viewSchedule(data.item)">
                      {{ data.item.sku_name }}
                    </b-link>
                  </template>

                  <template #cell(status)="data">
                    <span class="status-text" :class="getStatusClass(data.item.status)">
                      {{ data.item.status }}
                    </span>
                  </template>

                  <template #cell(scheduleStart)="data">
                    <p class="text-body m-0">{{ data.item.schedule_start | customFormatDate('Asia/Manila', 'MMMM D, YYYY [at] hh:mm A') }}</p>
                  </template>

                  <template #cell(scheduleEnd)="data">
                    <p class="text-body m-0">{{ data.item.schedule_end | customFormatDate('Asia/Manila', 'MMMM D, YYYY [at] hh:mm A') }}</p>
                  </template>

                  <template #cell(promoName)="data">
                    <p class="text-body m-0">{{ data.item.sku_name }}</p>
                  </template>

                  <template #cell(skuCode)="data">
                    <p class="text-body m-0">{{ data.item.sku_code }}</p>
                  </template>

                  <template #cell(provider)="data">
                    <p class="text-body fw-medium m-0">{{ data.item.provider_name }}</p>
                  </template>

                  <template #cell(amount)="data">
                    <p class="text-body m-0">PHP {{ data.item.amount }}</p>
                  </template>

                  <template #cell(validity)="data">
                    <p class="text-body m-0">{{ data.item.validity }}</p>
                  </template>

                  <template #cell(description)="data">
                    <p class="text-body m-0">
                      <span v-if="data.item.description && data.item.description.length > 50">
                        <span
                          class="d-inline-block"
                          tabindex="0"
                          style="border-bottom: 1px dotted #000; cursor: pointer;"
                          v-b-tooltip.hover="data.item.description"
                        >
                          {{ data.item.description.slice(0, 50) + '...' }}
                        </span>
                      </span>
                      <span v-else>
                        {{ data.item.description }}
                      </span>
                    </p>
                  </template>

                  <template #cell(created_by)="data">
                    <p class="text-body m-0">{{ data.item.created_by }}</p>
                  </template>
                </b-table>
              </div>
            </div>

            <div class="row g-0 text-center" v-if="loadPromoTotalRows == 0">
              <span>No data to display.</span>
            </div>

            <div class="row g-0 text-center text-sm-start" v-if="loadPromoTotalRows != 0">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="perPage"
                            :options="pageOptions"
                            @change="onDisplayChange()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="dataTables_paginate paging_simple_numbers float-end" v-if="loadPromoTotalRows > perPage">
                      <b-pagination
                        class="pagination-rounded"
                        v-model="currentPage"
                        @input="onPageUpdate()"
                        :total-rows="loadPromoTotalRows"
                        :per-page="perPage"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.action-btn {
  border: none;
  padding: 10px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
  width: 24px;
  height: 24px;
}

.action-btn-danger {
  background-color: #C12927;
  color: white;
}

.action-btn-danger:hover {
  background-color: #EF5350;
  transform: translateY(-1px);
}

.action-btn-danger:active {
  background-color: #D32F2F;
  transform: translateY(0);
}

.action-btn i, .action-btn span {
  font-size: 19px;
  line-height: 1;
}

.status-text {
  font-size: 14px;
  font-weight: 500;
}

.badge-scheduled {
  color: #4D56FF;
}

.badge-ongoing {
  color: #508F30;
}

.badge-ended {
  color: #AFAFAF;
}

.badge-cancelled {
  color: #C12928;
}

.badge-force-cancelled {
  color: #C12928;
}

.w-fit {
  width: fit-content;
}

.gap-2 {
  gap: 0.5rem;
}
</style>